import styled from 'styled-components';

import { Text12 } from '@sternum/ui';
import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const StyledBox = styled.div`
  background-color: ${Colors.BrandBlueLightest};
  color: ${Colors.BrandBlue};
  border-radius: 6px;
  position: absolute;
  top: 38px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;
`;

export const StyledRefreshText = styled(Text12)`
  font-weight: 600;
  color: ${ct({ Dark: Colors.BrandBlue, Light: Colors.BrandBlue })};
`;
